import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { fileUrl } from "../../lib/api";
import { Overline } from "./Reveal";

export default function FlavourCollection({ items = [], mode = "MENU" }) {
  const navigate = useNavigate();
  const [hover, setHover] = useState(null);
  const list = items.slice(0, 8);
  const n = list.length || 1;
  const paused = hover !== null;

  const go = (item) => {
    if (mode === "MENU") navigate(`/menus?c=${item.id}`);
    else navigate(`/gallery?cat=${encodeURIComponent(item.category || "")}`);
  };

  return (
    <section className="relative bg-burgundy grain overflow-hidden py-24 sm:py-32" data-testid="flavour-collection">
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 text-center">
        <Overline className="justify-center">Explore Our Culinary World</Overline>
        <h2 className="font-serif text-ivory text-4xl sm:text-5xl lg:text-6xl mt-4 mb-3">
          The Flavour <span className="gold-text italic">Collection</span>
        </h2>
        <p className="text-ivory/60 max-w-xl mx-auto text-sm sm:text-base">
          {mode === "MENU"
            ? "Hover to pause. Tap a dish to open its collection. Every plate, a signature."
            : "Hover to pause. Tap to enter that corner of our world."}
        </p>

        {/* Desktop orbital */}
        <div className="hidden md:flex justify-center mt-10">
          <div className="relative" style={{ width: 720, height: 720 }}>
            {/* rings */}
            <div className="absolute inset-0 rounded-full border border-gold/15" />
            <div className="absolute rounded-full border border-gold/10" style={{ inset: 90 }} />

            {/* center node */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20 text-center">
              <div className="w-40 h-40 rounded-full glass border border-gold/40 flex flex-col items-center justify-center float-slow">
                <span className="overline !text-gold/80">Foodie</span>
                <span className="font-serif text-gold text-3xl leading-none">Connect</span>
                <span className="text-ivory/50 text-[0.6rem] tracking-[0.3em] mt-1">CATERER</span>
              </div>
            </div>

            <div className={`orbit-rotate ${paused ? "paused" : ""} absolute inset-0`}>
              {list.map((item, i) => {
                const angle = (i / n) * Math.PI * 2 - Math.PI / 2;
                const R = 290;
                const x = 360 + R * Math.cos(angle);
                const y = 360 + R * Math.sin(angle);
                const active = hover === i;
                return (
                  <div key={item.id || i} className="absolute" style={{ left: x, top: y, transform: "translate(-50%,-50%)" }}>
                    <div className={`orbit-counter ${paused ? "paused" : ""}`}>
                      <button
                        onMouseEnter={() => setHover(i)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => go(item)}
                        data-testid={`orbital-item-${i}`}
                        className="group relative block"
                        style={{ transition: "transform .4s ease", transform: active ? "scale(1.22)" : "scale(1)" }}
                      >
                        <div className={`w-32 h-32 xl:w-36 xl:h-36 rounded-full overflow-hidden border-2 ${active ? "border-gold" : "border-gold/40"} shadow-2xl`}>
                          <img src={fileUrl(item.image)} alt={item.name} className="w-full h-full object-cover img-zoom" />
                        </div>
                        <div className={`absolute left-1/2 -bottom-9 -translate-x-1/2 whitespace-nowrap transition-all duration-300 ${active ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
                          <span className="text-gold font-serif text-lg">{item.name}</span>
                        </div>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Mobile swipe */}
        <div className="md:hidden mt-10 flex gap-4 overflow-x-auto hide-scrollbar pb-4 -mx-4 px-4 snap-x">
          {list.map((item, i) => (
            <button key={item.id || i} onClick={() => go(item)} data-testid={`orbital-mobile-${i}`} className="snap-center shrink-0 w-40 text-center">
              <div className="w-40 h-40 rounded-full overflow-hidden border-2 border-gold/40 mb-3">
                <img src={fileUrl(item.image)} alt={item.name} className="w-full h-full object-cover" />
              </div>
              <span className="text-gold font-serif text-lg leading-tight block">{item.name}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
